import React from "react";
import FormModal from "components/Modal/EditFormModal";
import { Form } from "antd";
import OccupationForm from "./OccupationForm";
import { useSelector } from "react-redux";

const EditOccupation = () => {
  const [form] = Form.useForm();
  const curdProps = useSelector((state) => state.CurdR);
  const { Edit_Occupation_Modal, Loader, initialValues } = curdProps;

  return (
    <FormModal
      modalTitle="Edit Occupation"
      submitButtonText="Update"
      cancelButtonText="Cancel"
      editApiRequest="EditRecord"
      apiLoader="StartSpinner"
      editApiMethod="PUT"
      editApiName="editOccupation"
      ModalName="Edit_Occupation_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Edit_Occupation_Modal ? Edit_Occupation_Modal : false}
      initialValues={initialValues}
      width={520}
      form={form}
      recordName="occupationList"
    >
      <OccupationForm />
    </FormModal>
  );
};

export default EditOccupation;
